import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api'
import { CourseInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'
import { coursesDependencies } from '../../../constants/courses-dependencies'

export function useCoursesList(id: string) {
  const { user } = useUser()

  const { data: courseList, mutate } = useControlledSwr<CourseInterface[]>(() => {
    if (user) {
      return [`${COURSE_BUNDLES_API}/${id}/list-all`, ...coursesDependencies]
    }
    return null
  }, baseFetcher)

  return { courseList, mutate }
}
